var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChurukou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4751"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631279",
    d: "M11.6039 3.51217V0.828735H0.5V15.1712H11.6039V12.3953",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 593",
    d: "M7.99524 6.54261H15.2128L13.1308 4.46063",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 594",
    d: "M15.5 9.47176L8.28248 9.47176L10.3645 11.5537",
    stroke: "black",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurukou);
export default __webpack_public_path__ + "static/media/churukou.f055f82ba4871717a8de015905eff3b4.svg";
export { ForwardRef as ReactComponent };